import { useState } from 'react'
import { message } from 'antd'
import type { Dispute } from '../types/dispute.types'

export const useDisputeActions = () => {
    const [selectedDispute, setSelectedDispute] = useState<Dispute | null>(null)
    const [isDetailDrawerOpen, setIsDetailDrawerOpen] = useState(false)

    const handleViewDetails = (dispute: Dispute) => {
        setSelectedDispute(dispute)
        setIsDetailDrawerOpen(true)
    }

    const handleAssignDispute = () => {
        message.success('Dispute assigned to Support Agent 2')
    }

    const handleResolveDispute = () => {
        message.success('Dispute marked as resolved!')
        setIsDetailDrawerOpen(false)
    }

    const handleSendMessage = (values: any) => {
        console.log('Sending message:', values)
        message.success('Message sent!')
    }
    
    const closeDrawer = () => setIsDetailDrawerOpen(false)

    return {
        selectedDispute,
        isDetailDrawerOpen,
        handleViewDetails,
        handleAssignDispute,
        handleResolveDispute,
        handleSendMessage,
        closeDrawer
    }
}
